<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->

      <div class="col-md-12">

        <br>
        <header><h5>Hall Allocation of the Faculty of Humanities and Social Sciences</h5></header>
        <br>

        <form [formGroup]="searchForm">
          <div class="row"><!-- Row -->
            <div class="col-sm-4">
              <div class="form-group">


                <div class="input-group input-group-lg">

                  <label for="from_date">From<span class="req-data">*&nbsp;&nbsp;</span></label>
                  <input class="form-control"
                         placeholder="{{plh_from_date}}"
                         id="from_date"
                         name="from_date"
                         ngbDatepicker #e="ngbDatepicker"
                         formControlName="from_date">
                  <div class="input-group-append">
                    <button class="btn-info btn-icon calendar" type="button" (click)="e.toggle()">
                      <i class="fa fa-calendar-o"></i>
                    </button>
                  </div>
                </div>

              </div>
            </div><!-- Col -->

            <div class="col-sm-4">
              <div class="form-group">

                <div class="input-group input-group-lg">
                  <label class="control-label" for="from_date">To<span class="req-data">*&nbsp;&nbsp;</span></label>
                  <input class="form-control"
                         placeholder="{{plh_to_date}}"
                         id="to_date"
                         name="to_date"
                         formControlName="to_date"
                         ngbDatepicker #f="ngbDatepicker">
                  <div class="input-group-append">
                    <button class="btn-info btn-icon calendar" type="button" (click)="f.toggle()">
                      <i class="fa fa-calendar-o"></i>
                    </button>
                  </div>
                </div>

              </div>
            </div><!-- Col -->

            <div class="col-sm-4">
              <!--Save Button-->
              <ng-container>
                <button type="button"
                        class="btn btn-info "
                        (click)="getBookings()">
                  <i class="fa fa-search"></i>
                  Search Bookings
                </button>
              </ng-container>
            </div>

          </div>
        </form>

        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-12 col-md-12">
                <div class="card">
                  <div class="card-body">

                    <!--CSS Loader-->
                    <section *ngIf="isLoading">
                      <div class="ph-item ph-item-new ph-margin" *ngFor="let x of newsRepat">
                        <div class="ph-col-3 ph-margin">
                          <div class="ph-picture"></div>
                        </div>
                        <div class="ph-col-3 ph-margin">
                          <div class="ph-picture"></div>
                        </div>
                        <div class="ph-col-3 ph-margin">
                          <div class="ph-picture"></div>
                        </div>
                        <div class="ph-col-3 ph-margin">
                          <div class="ph-picture"></div>
                        </div>

                      </div>
                    </section>
                    <!--CSS Loader-->

                    <full-calendar *ngIf="!isLoading"
                      [options]='calendarOptions'
                    ></full-calendar>
                  </div>
                  </div>
              </div>
            </div>
          </div>
        </div>

        <div id="fullCalModal" class="modal fade">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 id="modalTitle1" class="modal-title"></h4>
                <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span> <span class="sr-only">close</span></button>
              </div>
              <div id="modalBody1" class="modal-body"></div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                <button class="btn btn-primary">Event Page</button>
              </div>
            </div>
          </div>
        </div>

        <div id="createEventModal" class="modal fade">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 id="modalTitle2" class="modal-title">Add event</h4>
                <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span> <span class="sr-only">close</span></button>
              </div>
              <div id="modalBody2" class="modal-body">
                <form>
                  <div class="form-group">
                    <label for="formGroupExampleInput">Example label</label>
                    <input type="text" class="form-control" id="formGroupExampleInput" placeholder="Example input">
                  </div>
                  <div class="form-group">
                    <label for="formGroupExampleInput2">Another label</label>
                    <input type="text" class="form-control" id="formGroupExampleInput2" placeholder="Another input">
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                <button class="btn btn-primary">Add</button>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>
